module.exports = __webpack_public_path__ + "img/rauxiliacamp64_ua.d25cf15e.webp";